import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyB1bg-oZcLpumg08zsq4DZTaNU6hFTZo2Q",
  authDomain: "post-it-app-6c283.firebaseapp.com",
  databaseURL: "https://post-it-app-6c283.firebaseio.com",
  projectId: "post-it-app-6c283",
  storageBucket: "post-it-app-6c283.appspot.com",
  messagingSenderId: "674215972819",
  appId: "1:674215972819:web:ad82a3c5b321eb9a6f6926",
  measurementId: "G-HEE5W6V7N4"

  });

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();

export { db, auth, storage };